import { graphql } from 'gatsby';

// nothing good comes from peeking behind the curtains

export const articleSlices = graphql`
  fragment articleSlices on PRISMIC_ArticleBody {
    __typename
    ... on PRISMIC_ArticleBodyText {
      type
      primary {
        text
        separator
      }
    }
    ... on PRISMIC_ArticleBodyRichtext {
      type
      primary {
        lead
        column_a
        column_b
        separator
      }
    }
    ... on PRISMIC_ArticleBodySingle_image {
      type
      primary {
        image
        caption
        separator
      }
    }
    ... on PRISMIC_ArticleBodyImage_gallery {
      type
      primary {
        display
        separator
      }
      fields {
        image
        caption
      }
    }
    ... on PRISMIC_ArticleBodyVideo {
      type
      primary {
        video
        caption
        credits
        separator
      }
    }
    ... on PRISMIC_ArticleBodyCta {
      type
      primary {
        heading
        text
        link_text
        cta_image
        link {
          _linkType
          ...linkable
        }
        separator
      }
    }
    ... on PRISMIC_ArticleBodyList {
      type
      primary {
        list_title
        list_image
        list_image_caption
        separator
      }
      fields {
        text
        link {
          ...linkable
        }
      }
    }
    ... on PRISMIC_ArticleBodyQuote {
      type
      primary {
        quote
        citation
        separator
      }
    }
    ... on PRISMIC_ArticleBodyEmbed {
      type
      primary {
        embed
        separator
      }
    }
    ... on PRISMIC_ArticleBodyRelated_items {
      type
      primary {
        related_title
        separator
      }
      fields {
        __typename
        content {
          __typename
          ...article
          ...page
          ...project
          ...association
        }
      }
    }
    ... on PRISMIC_ArticleBodyPartners_list {
      type
      primary {
        partners_title
        separator
      }
      fields {
        partner_title
        logo
        link {
          ...linkable
        }
      }
    }
    ... on PRISMIC_ArticleBodyPeople {
      type
      primary {
        people_title
        people_image
        placeholder_color
        separator
      }
      fields {
        person {
          ...person
        }
      }
    }
    ... on PRISMIC_ArticleBodyIframe {
      type
      primary {
        iframe_title
        link {
          ...linkable
        }
        separator
      }
    }
    ... on PRISMIC_ArticleBodyTabs {
      type
      primary {
        tabs_title
        separator
      }
      fields {
        tab_title
        tab_content
      }
    }
    ... on PRISMIC_ArticleBodyHeading {
      type
      primary {
        heading
        separator
      }
    }
    ... on PRISMIC_ArticleBodyCards {
      type
      primary {
        column_number
        separator
      }
      fields {
        title1
        metadata1
        link {
          ...linkable
        }
        link_title
        size
        color
      }
    }
    ... on PRISMIC_ArticleBodyDescriptive_list {
      type
      label
      primary {
        list_title
        list_image
        separator
      }
      fields {
        list_title
        text
        footer
        link {
          _linkType
          ...linkable
        }
      }
    }
    ... on PRISMIC_ArticleBodyImage_grid {
      type
      primary {
        title1
      }
      fields {
        image1
        link {
          ...linkable
        }
      }
    }
  }
`;

export const pageSlices = graphql`
  fragment pageSlices on PRISMIC_PageBody {
    __typename
    ... on PRISMIC_PageBodyText {
      type
      primary {
        text
        separator
      }
    }
    ... on PRISMIC_PageBodyRichtext {
      type
      primary {
        lead
        column_a
        column_b
      }
    }
    ... on PRISMIC_PageBodySingle_image {
      type
      primary {
        image
        caption
      }
    }
    ... on PRISMIC_PageBodyImage_gallery {
      type
      primary {
        display
      }
      fields {
        image
        caption
      }
    }
    ... on PRISMIC_PageBodyVideo {
      type
      primary {
        video
        caption
        credits
      }
    }
    ... on PRISMIC_PageBodyCta {
      type
      primary {
        heading
        text
        link_text
        cta_image
        link {
          _linkType
          ...linkable
        }
        separator
      }
    }
    ... on PRISMIC_PageBodyList {
      type
      primary {
        list_title
        list_image
        list_image_caption
      }
      fields {
        text
        link {
          ...linkable
        }
      }
    }
    ... on PRISMIC_PageBodyQuote {
      type
      primary {
        quote
        citation
      }
    }
    ... on PRISMIC_PageBodyEmbed {
      type
      primary {
        embed
      }
    }
    ... on PRISMIC_PageBodyRelated_items {
      type
      primary {
        related_title
      }
      fields {
        __typename
        content {
          __typename
          ...article
          ...page
          ...project
          ...association
          ...externalCta
        }
      }
    }
    ... on PRISMIC_PageBodyPartners_list {
      type
      primary {
        partners_title
        separator
      }
      fields {
        partner_title
        logo
        link {
          ...linkable
        }
      }
    }
    ... on PRISMIC_PageBodyPeople {
      type
      primary {
        people_title
        people_image
        placeholder_color
        separator
      }
      fields {
        person {
          ...person
        }
      }
    }
    ... on PRISMIC_PageBodyIframe {
      type
      primary {
        iframe_title
        link {
          ...linkable
        }
      }
    }
    ... on PRISMIC_PageBodyTabs {
      type
      primary {
        tabs_title
      }
      fields {
        tab_title
        tab_content
      }
    }
    ... on PRISMIC_PageBodyHeading {
      type
      primary {
        heading
      }
    }
    ... on PRISMIC_PageBodyCards {
      type
      primary {
        column_number
        separator
      }
      fields {
        title1
        metadata1
        link {
          ...linkable
        }
        link_title
        size
        color
      }
    }
    ... on PRISMIC_PageBodyDescriptive_list {
      type
      label
      primary {
        list_title
        list_image
        separator
      }
      fields {
        list_title
        text
        footer
        link {
          _linkType
          ...linkable
        }
      }
    }
    ... on PRISMIC_PageBodyImage_grid {
      type
      primary {
        title1
        separator
      }
      fields {
        image1
        link {
          ...linkable
        }
      }
    }
  }
`;

export const projectSlices = graphql`
  fragment projectSlices on PRISMIC_ProjectBody {
    __typename
    ... on PRISMIC_ProjectBodyText {
      type
      primary {
        text
        separator
      }
    }
    ... on PRISMIC_ProjectBodyText {
      type
      primary {
        text
        separator
      }
    }
    ... on PRISMIC_ProjectBodyRichtext {
      type
      primary {
        lead
        column_a
        column_b
        separator
      }
    }
    ... on PRISMIC_ProjectBodySingle_image {
      type
      primary {
        image
        caption
        separator
      }
    }
    ... on PRISMIC_ProjectBodyImage_gallery {
      type
      primary {
        display
        separator
      }
      fields {
        image
        caption
      }
    }
    ... on PRISMIC_ProjectBodyVideo {
      type
      primary {
        video
        caption
        credits
        separator
      }
    }
    ... on PRISMIC_ProjectBodyCta {
      type
      primary {
        heading
        text
        link_text
        cta_image
        link {
          _linkType
          ...linkable
        }
        separator
      }
    }
    ... on PRISMIC_ProjectBodyList {
      type
      primary {
        list_title
        list_image
        list_image_caption
        separator
      }
      fields {
        text
        link {
          ...linkable
        }
      }
    }
    ... on PRISMIC_ProjectBodyQuote {
      type
      primary {
        quote
        citation
        separator
      }
    }
    ... on PRISMIC_ProjectBodyEmbed {
      type
      primary {
        embed
        separator
      }
    }
    ... on PRISMIC_ProjectBodyRelated_items {
      type
      primary {
        related_title
        separator
      }
      fields {
        __typename
        content {
          __typename
          ...article
          ...page
          ...project
          ...association
        }
      }
    }
    ... on PRISMIC_ProjectBodyPartners_list {
      type
      primary {
        partners_title
        separator
      }
      fields {
        partner_title
        logo
        link {
          ...linkable
        }
      }
    }
    ... on PRISMIC_ProjectBodyPeople {
      type
      primary {
        people_title
        people_image
        placeholder_color
        separator
      }
      fields {
        person {
          ...person
        }
      }
    }
    ... on PRISMIC_ProjectBodyIframe {
      type
      primary {
        iframe_title
        link {
          ...linkable
        }
        separator
      }
    }
    ... on PRISMIC_ProjectBodyTabs {
      type
      primary {
        tabs_title
        separator
      }
      fields {
        tab_title
        tab_content
      }
    }
    ... on PRISMIC_ProjectBodyHeading {
      type
      primary {
        heading
        separator
      }
    }
    ... on PRISMIC_ProjectBodyCards {
      type
      primary {
        column_number
        separator
      }
      fields {
        title1
        metadata1
        link {
          ...linkable
        }
        link_title
        size
        color
      }
    }
    ... on PRISMIC_ProjectBodyDescriptive_list {
      type
      label
      primary {
        list_title
        list_image
        separator
      }
      fields {
        list_title
        text
        footer
        link {
          _linkType
          ...linkable
        }
      }
    }
    ... on PRISMIC_ProjectBodyImage_grid {
      type
      primary {
        title1
        separator
      }
      fields {
        image1
        link {
          ...linkable
        }
      }
    }
  }
`;

export const associationSlices = graphql`
  fragment associationSlices on PRISMIC_AssociationBody {
    __typename
    ... on PRISMIC_AssociationBodyText {
      type
      primary {
        text
        separator
      }
    }
    ... on PRISMIC_AssociationBodyRichtext {
      type
      primary {
        lead
        column_a
        column_b
        separator
      }
    }
    ... on PRISMIC_AssociationBodySingle_image {
      type
      primary {
        image
        caption
        separator
      }
    }
    ... on PRISMIC_AssociationBodyImage_gallery {
      type
      primary {
        display
        separator
      }
      fields {
        image
        caption
      }
    }
    ... on PRISMIC_AssociationBodyVideo {
      type
      primary {
        video
        caption
        credits
        separator
      }
    }
    ... on PRISMIC_AssociationBodyCta {
      type
      primary {
        heading
        text
        link_text
        cta_image
        link {
          _linkType
          ...linkable
        }
        separator
      }
    }
    ... on PRISMIC_AssociationBodyList {
      type
      primary {
        list_title
        list_image
        list_image_caption
        separator
      }
      fields {
        text
        link {
          ...linkable
        }
      }
    }
    ... on PRISMIC_AssociationBodyQuote {
      type
      primary {
        quote
        citation
        separator
      }
    }
    ... on PRISMIC_AssociationBodyEmbed {
      type
      primary {
        embed
        separator
      }
    }
    ... on PRISMIC_AssociationBodyRelated_items {
      type
      primary {
        related_title
        separator
      }
      fields {
        __typename
        content {
          __typename
          ...article
          ...page
          ...project
          ...association
        }
      }
    }
    ... on PRISMIC_AssociationBodyPartners_list {
      type
      primary {
        partners_title
        separator
      }
      fields {
        partner_title
        logo
        link {
          ...linkable
        }
      }
    }
    ... on PRISMIC_AssociationBodyPeople {
      type
      primary {
        people_title
        people_image
        placeholder_color
        separator
      }
      fields {
        person {
          ...person
        }
      }
    }
    ... on PRISMIC_AssociationBodyIframe {
      type
      primary {
        iframe_title
        link {
          ...linkable
        }
        separator
      }
    }
    ... on PRISMIC_AssociationBodyTabs {
      type
      primary {
        tabs_title
        separator
      }
      fields {
        tab_title
        tab_content
      }
    }
    ... on PRISMIC_AssociationBodyHeading {
      type
      primary {
        heading
        separator
      }
    }
    ... on PRISMIC_AssociationBodyCards {
      type
      primary {
        column_number
        separator
      }
      fields {
        title1
        metadata1
        link {
          ...linkable
        }
        link_title
        size
        color
      }
    }
    ... on PRISMIC_AssociationBodyDescriptive_list {
      type
      label
      primary {
        list_title
        list_image
        separator
      }
      fields {
        list_title
        text
        footer
        link {
          _linkType
          ...linkable
        }
      }
    }
    ... on PRISMIC_AssociationBodyImage_grid {
      type
      primary {
        title1
        separator
      }
      fields {
        image1
        link {
          ...linkable
        }
      }
    }
  }
`;
